export const calculatePercentageChange = (newValue, oldValue) => {
  const diffBetweenNewAndOldValue = newValue - oldValue

  if (diffBetweenNewAndOldValue === 0) return 0

  const percentageChange = ((newValue - oldValue) / oldValue) * 100

  return Number(percentageChange.toFixed(0))
}
